import React from 'react'
import PropTypes from 'prop-types'

class RegistrationForm extends React.Component {
  render() {
    return (
      <div className="card event-page__form u-text-left">
        <div className="l-inner-large">
          <p className="heading-18 event-page__form-title">Book a meeting</p>
        </div>
      </div>
    )
  }
}

RegistrationForm.propTypes = {
  eventId: PropTypes.string,
}

export default RegistrationForm
